import Vue from "vue";

export default new Vue({
  computed: {
    eventName(): string {
      return 'refresh-entry-data';
    },
  },
  methods: {
    emitRefresh(): void {
      this.$emit(this.eventName);
    },
    onRefresh(callback: Function): void {
      this.$on(this.eventName, callback);
    },
  },
});